import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonBase = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
`;

export const SkeletonText = styled(SkeletonBase)`
  height: var(--skeleton-line-height, 16px);
  width: 100%;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SkeletonTextShort = styled(SkeletonBase)`
  height: var(--skeleton-line-height, 16px);
  width: 60%;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SkeletonTextLong = styled(SkeletonBase)`
  height: var(--skeleton-line-height, 16px);
  width: 80%;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SkeletonAvatar = styled(SkeletonBase)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const SkeletonBadge = styled(SkeletonBase)`
  height: 24px;
  width: 80px;
  border-radius: 12px;
`;

export const SkeletonTableRow = styled.div`
  display: grid;
  grid-template-columns: var(--table-grid-columns, repeat(auto-fit, minmax(100px, 1fr)));
  gap: var(--table-grid-gap, 0.5rem);
  padding: var(--table-row-padding, 1rem);
  border-bottom: var(--table-row-border, 1px solid #e9ecef);
  align-items: center;
  background: var(--table-row-background, white);
`;

export const SkeletonTableCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  > * {
    margin-bottom: 0;
  }
`;
